<template>
  <div class="main-box main-content">
      <el-form ref="dataForm" id="dataForm" :model="temp"   label-width="90px" label-suffix="：" class="main-form" size="small">
        <!-- 基本信息 -->
        <xr-collapse class="single-collapse">
          <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs" >
            <el-tab-pane label="基本信息">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="姓名" prop="sickName" required>
                    <el-input v-model="temp.sickName" :class="{ 'input-error': errors.sickName }" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="编号" prop="archiveCode" required>
                    <el-input v-model="temp.archiveCode" :class="{ 'input-error': errors.archiveCode }" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系日期">
                    <el-date-picker v-model="temp.contactTime" type="date" value-format="yyyy-MM-dd" placeholder="选择联系日期" style="width: 100%" :readonly="isReadOnly"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="录入医生" >
                    <el-input v-model="temp.contactOperatorName"  readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="团队成员姓名">
                    <el-input v-model="temp.contactOperatorName" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="人员身份">
                    <el-select v-model="temp.memberType" placeholder="请选择人员身份" class="input-bg" style="width: 100%;" :class="{ 'is-readonly': isReadOnly }">
                      <el-option v-for="(item, index) in memberType_list" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </xr-collapse>
      <!-- 联系方式 -->
        <xr-collapse class="single-collapse">
          <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
            <el-tab-pane label="联系方式">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="面对面">
                    <el-radio-group v-model="temp.contactWay"  :class="{ 'is-readonly': isReadOnly }">
                      <el-radio v-for="(item, index) in contactWayOptions" :key="index" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="非面对面">
                    <el-radio-group v-model="temp.contactWay"  :class="{ 'is-readonly': isReadOnly }">
                      <el-radio v-for="(item, index) in nonContactWayOptions" :key="'non'+index" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </xr-collapse>
        <!-- 联系内容 -->
        <xr-collapse class="single-collapse">
          <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
            <el-tab-pane label="联系方式">
              <!-- 签约服务 -->
              <el-form-item label="签约服务">
                <el-checkbox v-model="temp.signQytz" true-label="1" false-label="0">签约通知</el-checkbox>
                <el-checkbox v-model="temp.signYyqy" true-label="1" false-label="0">预约通知</el-checkbox>
                <el-checkbox v-model="temp.signXytx" true-label="1" false-label="0">续约提醒</el-checkbox>
                <el-checkbox v-model="temp.signJqfwjs" true-label="1" false-label="0">家医服务介绍</el-checkbox>
                <el-checkbox v-model="temp.signJkzkxwzd" true-label="1" false-label="0">健康状况询问与指导</el-checkbox>
                <el-checkbox v-model="temp.signQt1" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.signQt1Str" :readonly="temp.signQt1 != '1'"  style="width: 200px;"></el-input>
                <el-checkbox v-model="temp.signQt2" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.signQt2Str" :readonly="temp.signQt2 != '1'"  style="width: 200px;"></el-input>
              </el-form-item>

              <!-- 基本公共卫生服务 -->
              <el-form-item label="基本公共卫生服务">
                <el-checkbox v-model="temp.gwServiceTzjd" true-label="1" false-label="0">通知建立健康档案</el-checkbox>
                <el-checkbox v-model="temp.gwServiceBghc" true-label="1" false-label="0">档案信息变更与核查</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJyzd" true-label="1" false-label="0">健康教育与管理</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJkts" true-label="1" false-label="0">发放健康贴士</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJztz" true-label="1" false-label="0">健康讲座通知</el-checkbox>
                <el-checkbox v-model="temp.gwServiceYztz" true-label="1" false-label="0">义诊通知</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJkzx" true-label="1" false-label="0">居民健康咨询</el-checkbox>
                <el-checkbox v-model="temp.gwServiceCrbtx" true-label="1" false-label="0">季节性传染病提醒</el-checkbox>
                <el-checkbox v-model="temp.gwServiceTjsfyy" true-label="1" false-label="0">体检随访预约</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJktj" true-label="1" false-label="0">健康体检</el-checkbox>
                <el-checkbox v-model="temp.gwServiceTjbgff" true-label="1" false-label="0">体检报告发放</el-checkbox>
                <el-checkbox v-model="temp.gwServiceTnbsf" true-label="1" false-label="0">糖尿病慢病随访</el-checkbox>
                <el-checkbox v-model="temp.gwServiceGxysf" true-label="1" false-label="0">高血压慢病随访</el-checkbox>
                <el-checkbox v-model="temp.gwServiceQtsf" true-label="1" false-label="0">其他慢病随访</el-checkbox>
                <el-checkbox v-model="temp.gwServiceFjhsc" true-label="1" false-label="0">肺结核筛查管理</el-checkbox>
                <el-checkbox v-model="temp.gwServiceLnrzytz" true-label="1" false-label="0">老年人中医体质辨识</el-checkbox>
                <el-checkbox v-model="temp.gwServiceEtzyy" true-label="1" false-label="0">儿童中医药健康管理</el-checkbox>
                <el-checkbox v-model="temp.gwServiceDcasc" true-label="1" false-label="0">大肠癌筛查</el-checkbox>
                <el-checkbox v-model="temp.gwServiceFnlasc" true-label="1" false-label="0">育龄妇女</el-checkbox>
                <el-checkbox v-model="temp.gwServiceXnxg" true-label="1" false-label="0">心脑血管疾病筛查</el-checkbox>
                <el-checkbox v-model="temp.gwServiceMzfsc" true-label="1" false-label="0">慢阻肺筛查</el-checkbox>
                <el-checkbox v-model="temp.gwServiceQtsc" true-label="1" false-label="0">其他慢病筛查</el-checkbox>
                <el-checkbox v-model="temp.gwServiceEtjkgl" true-label="1" false-label="0">儿童健康管理</el-checkbox>
                <el-checkbox v-model="temp.gwServiceJztx" true-label="1" false-label="0">预防接种提醒</el-checkbox>
                <el-checkbox v-model="temp.gwServiceYcfgl" true-label="1" false-label="0">孕产妇健康管理</el-checkbox>
                <el-checkbox v-model="temp.gwServiceChfsyy" true-label="1" false-label="0">产后访视预约</el-checkbox>
                <el-checkbox v-model="temp.gwServiceQt1" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.gwServiceQt1Str" :readonly="temp.gwServiceQt1 != '1'"  style="width: 200px;"></el-input>
                <el-checkbox v-model="temp.gwServiceQt2" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.gwServiceQt2Str" :readonly="temp.gwServiceQt2 != '1'"  style="width: 200px;"></el-input>
              </el-form-item>

              <!-- 基本医疗服务 -->
              <el-form-item label="基本医疗服务">
                <el-checkbox v-model="temp.ylServiceZlyy" true-label="1" false-label="0">诊疗预约服务</el-checkbox>
                <el-checkbox v-model="temp.ylServiceZzhsf" true-label="1" false-label="0">转诊后随访</el-checkbox>
                <el-checkbox v-model="temp.ylServiceYlzx" true-label="1" false-label="0">居民医疗咨询</el-checkbox>
                <el-checkbox v-model="temp.ylServiceYszx" true-label="1" false-label="0">药事咨询服务</el-checkbox>
                <el-checkbox v-model="temp.ylServiceWjtz" true-label="1" false-label="0">体检危急值通知</el-checkbox>
                <el-checkbox v-model="temp.ylServiceZyxc" true-label="1" false-label="0">中医适宜技术宣传</el-checkbox>
                <el-checkbox v-model="temp.ylServiceZyykfzd" true-label="1" false-label="0">中医药及康复指导</el-checkbox>
                <el-checkbox v-model="temp.ylServiceXlaw" true-label="1" false-label="0">心理安慰（非咨询）</el-checkbox>
                <el-checkbox v-model="temp.ylServiceQt1" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.ylServiceQt1Str" :readonly="temp.ylServiceQt1 != '1'"  style="width: 200px;"></el-input>
                <el-checkbox v-model="temp.ylServiceQt2" true-label="1" false-label="0"></el-checkbox>
                <el-input class="input-bg" v-model="temp.ylServiceQt2Str" :readonly="temp.ylServiceQt2 != '1'"  style="width: 200px;"></el-input>
              </el-form-item>

              <!-- 个性化健康服务 -->
              <el-form-item label="个性化健康服务">
                <el-checkbox v-model="temp.gxhServiceTxsm" true-label="1" false-label="0">特需上门服务</el-checkbox>
                <el-checkbox v-model="temp.gxhServiceJtbc" true-label="1" false-label="0">家庭病床服务</el-checkbox>
                <el-checkbox v-model="temp.gxhServiceJkgl" true-label="1" false-label="0">健康管理服务</el-checkbox>
                <el-checkbox v-model="temp.gxhServiceZyzwb" true-label="1" false-label="0">中医治未病宣传</el-checkbox>
                <el-checkbox v-model="temp.gxhServiceXxhyl" true-label="1" false-label="0">信息化医疗服务</el-checkbox>
                <el-checkbox v-model="temp.gxhServiceQt1" true-label="1" false-label="0">其他1</el-checkbox>
                <el-input class="input-bg" v-model="temp.gxhServiceQt1Str" :readonly="temp.gxhServiceQt1 != '1'"  style="width: 200px;"></el-input>
                <el-checkbox v-model="temp.gxhServiceQt2" true-label="1" false-label="0">其他2</el-checkbox>
                <el-input class="input-bg" v-model="temp.gxhServiceQt2Str" :readonly="temp.gxhServiceQt2 != '1'"  style="width: 200px;"></el-input>
              </el-form-item>

              <!-- 备注 -->
              <el-form-item label="备注">
                <el-input v-model="temp.remark" placeholder="请输入备注" type="textarea" rows="3" :readonly="isReadOnly"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </xr-collapse>
<!--        &lt;!&ndash; 提交按钮 &ndash;&gt;-->
<!--        <div class="form-buttons" style="margin-top: 20px; text-align: center;">-->
<!--          <el-button type="primary" v-if="temp.processStatus == '0'" @click="submitForm(0)">保存</el-button>-->
<!--          <el-button type="success" v-if="temp.processStatus == '0'" @click="submitForm(1)">提交</el-button>-->
<!--          <el-button @click="close">取消</el-button>-->
<!--        </div>-->
      </el-form>
  </div>
</template>
<script>
	export default {
		data() {
			return {
        archiveInfo: {
          manageTeam: ''
        },
        dialogVisible: false,   //是否显示
        dialogName:'编辑主动联系信息',
				selectedItems: [],
				signServiceSelected: [],
				publicHealthSelected: [],
				basicMedicalSelected: [],
				specialMedicalSelected: [],
        memberType_list: [
          {value: '1', label: '家庭医生'},
          {value: '2', label: '社区护士'},
          {value: '3', label: '公卫医师'},
          {value: '4', label: '其他成员'}
        ],
        teamUserList: [],
				manageTeamOptions: [
					'家庭医生',
					'社区护士',
					'公卫医师',
					'其他成员'
				],

				// 人员身份值映射 - 文字对应的编号
				manageTeamValues: {
					'家庭医生': '1',
					'社区护士': '2',
					'公卫医师': '3',
					'其他成员': '4'
				},

				// 面对面选项
				contactWayOptions: [
					{ value: '1', label: '门诊' },
					{ value: '2', label: '家庭' },
					{ value: '3', label: '社区' },
					{ value: '4', label: '党群' },
					{ value: '5', label: '其他场所' }
				],

				// 非面对面选项
				nonContactWayOptions: [
					{ value: '7', label: '短信' },
					{ value: '8', label: '微信' },
					{ value: '6', label: '人工电话' },
					{ value: '9', label: '智能电话' }
				],

				// 错误信息
				errors: {
					sickName: false,
					archiveCode: false
				},
        type: 'edit',
				// 提交用的数据
				temp: {
          id:'',
					// 基本信息
					archiveId: '',
					sickName: '',
					archiveCode: '',
					contactTime: '',
          contactOperatorName: '',
					memberType: '',
					memberTypeName: '',
					manageTeam: '', // 默认选择家庭医生
					identityCardNo: '',

					// 联系方式
					contactWay: '',
					contactWayName: '',

					// 签约服务
					signQytz: '0',
					signYyqy: '0',
					signXytx: '0',
					signJqfwjs: '0',
					signJkzkxwzd: '0',
					signQt1: '0',
					signQt1Str: '',
					signQt2: '0',
					signQt2Str: '',
					gwServiceTzjd: '0',
					gwServiceBghc: '0',
					gwServiceJyzd: '0',
					gwServiceJkts: '0',
					gwServiceJztz: '0',
					gwServiceYztz: '0',
					gwServiceJkzx: '0',
					gwServiceCrbtx: '0',
					gwServiceTjsfyy: '0',
					gwServiceJktj: '0',
					gwServiceTjbgff: '0',
					gwServiceTnbsf: '0',
					gwServiceGxysf: '0',
					gwServiceQtsf: '0',
					gwServiceFjhsc: '0',
					gwServiceLnrzytz: '0',
					gwServiceEtzyy: '0',
					gwServiceDcasc: '0',
					gwServiceFnlasc: '0',
					gwServiceXnxg: '0',
					gwServiceMzfsc: '0',
					gwServiceQtsc: '0',
					gwServiceEtjkgl: '0',
					gwServiceJztx: '0',
					gwServiceYcfgl: '0',
					gwServiceChfsyy: '0',
					gwServiceQt1: '0',
					gwServiceQt1Str: '',
					gwServiceQt2: '0',
					gwServiceQt2Str: '',
					ylServiceZlyy: '0',
					ylServiceZzhsf: '0',
					ylServiceYlzx: '0',
					ylServiceYszx: '0',
					ylServiceWjtz: '0',
					ylServiceZyxc: '0',
					ylServiceZyykfzd: '0',
					ylServiceXlaw: '0',
					ylServiceQt1: '0',
					ylServiceQt1Str: '',
					ylServiceQt2: '0',
					ylServiceQt2Str: '',
					gxhServiceTxsm: '0',
					gxhServiceJtbc: '0',
					gxhServiceJkgl: '0',
					gxhServiceZyzwb: '0',
					gxhServiceXxhyl: '0',
					gxhServiceQt1: '0',
					gxhServiceQt1Str: '',
					gxhServiceQt2: '0',
					gxhServiceQt2Str: '',

					// 备注
					remark: '',
					processStatus:''
				},
			}
		},
		computed: {
			 isReadOnly() {
				 return this.temp.processStatus === '1'
			 }
		},

		methods: {
			//初始化
			init(type, id){
			  this.type = type;
			  this.temp.id = id;
			  this.getPageInfo(type, id);
			},
			//获取主动联系具体信息
      getPageInfo(type, id){
        if(type == 'save'){
          this.createAddInfo();
        }
				const app = this
				return this.request({
				  method:'post',
				  url:'/web/service',
				  params:{
				    'method': 'tPhDataContact_getPageInfo',
            'type': this.type,
            'manageTeam': this.archiveInfo.manageTeam,
				    'id': this.temp.id
				  }
				}).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }

          if(!!response.data.info) {
            // 将后端返回的数据映射到temp
            this.temp = response.data.info;
          }

        })
			},
      //保存
      save(formName){
        let url = '/web/service?method=tPhDataContact_edit'
        if (this.type === 'save') {
          url = '/web/service?method=tPhDataContact_save'
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            return this.request({
              method: 'post',
              url: url,
              params: this.temp
            }).then((response) =>{
              if (response.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.dialogVisible = false
                    // this.$emit('callBackMethod')  TODO 加载左边树
                  }
                })
              } else {
                this.$message.error(response.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      //补充新增信息
      createAddInfo(){
			  this.temp.archiveId = this.archiveInfo.archiveId;
			  this.temp.archiveCode = this.archiveInfo.archiveCode;
			  this.temp.sickName = this.archiveInfo.sickName;
			  this.temp.identityCardNo = this.archiveInfo.identityCardNo;
			  //TODO 完善其他的
      },

			// 准备提交的数据
			prepareSubmitData() {
				const submitData = { ...this.temp };
				submitData.manageTeam = this.getmanageTeamValue();
				this.updateContactWayName();
				submitData.contactWayName = this.temp.contactWayName;
				return submitData;
			},
			// 通用提交方法
			doSubmit(processStatus) {
				let msg = '提交后的数据不能再次修改，确定要提交吗?'
				if(processStatus ==0){
					msg = '确定要保存吗？'
				}
        const _self = this
        this.$confirm(msg, '提示',
            {confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
              return this.request({
                method:'post',
                url:'/web/service',
                params:{
                  method: 'tPhDataContact_edit',
                  ...this.temp,
                  id: this.temp.id,
                  processStatus: processStatus
                }
              }).then(result => {
                  //如果返回编码不为0，提示失败语
                  if (result.code != '0') {
                    _self.$message.warning(result.msg);
                    return false;
                  }
                  _self.$message.success('操作成功')
                  _self.dialogVisible = false
                  _self.$emit('refreshData')
              })
        })
			},
			//表单提交
			submitForm(processStatus) {
				// 判断是否为已保存的记录，如果是已保存的记录不需要校验直接提交
				if (processStatus ==0) {
					this.doSubmit(processStatus);
					return;
				}
				// 调用验证方法检查本季度是否已有记录
				this.checkCurrentQuarterDataIsExist().then(isExist => {
					if (isExist) {
						// 如果本季度已存在记录，不继续提交
						return;
					}
					let flag = this.validateForm()
          if(!flag) return
					this.doSubmit(processStatus);
				});
			},
			//校验本季度是否已存在记录
			checkCurrentQuarterDataIsExist(processStatus){
          // 如果processStatus为0，不需要验证，直接返回false
          if(processStatus == 0 || this.temp.processStatus === '0') {
            return;
          }
          const _self = this
          return this.request({
            method:'post',
            url:'/web/service',
            params:{
              method: 'tPhAppService_queryCurrentQuarterRecord',
              type: 'concat',
              archiveId: this.temp.archiveId
            },
          }).then(result => {
              //如果返回编码不为0，提示失败语
              if (result.code != '0') {
                _self.$message.warning(result.msg);
                return false;
              }
              if(result.data.list && result.data.list.length>0){
              	_self.$message.warning('该居民本季度主动联系已存在，无需重复提交！')
                return true
              }
              return false
          })
			},
			validateForm(){
        if(!this.temp.contactTime){
          this.$message.warning('联系日期不能为空')
          return false
        }
        return true
      },
      //重置
      resetTemp() {

			  this.temp.memberType = '';
			  this.temp.memberTypeName = '';

			  this.temp.contactWay = '';
			  this.temp.contactWayName = '';

        this.temp.signQytz = '0';
        this.temp.signYyqy = '0';
        this.temp.signXytx = '0';
        this.temp.signJqfwjs = '0';
        this.temp.signJkzkxwzd = '0';
        this.temp.signQt1 = '0';
        this.temp.signQt1Str = '';
        this.temp.signQt2 = '0';
        this.temp.signQt2Str = '';
        this.temp.gwServiceTzjd = '0';
        this.temp.gwServiceBghc = '0';
        this.temp.gwServiceJyzd = '0';
        this.temp.gwServiceJkts = '0';
        this.temp.gwServiceJztz = '0';
        this.temp.gwServiceYztz = '0';
        this.temp.gwServiceJkzx = '0';
        this.temp.gwServiceCrbtx = '0';
        this.temp.gwServiceTjsfyy = '0';
        this.temp.gwServiceJktj = '0';
        this.temp.gwServiceTjbgff = '0';
        this.temp.gwServiceTnbsf = '0';
        this.temp.gwServiceGxysf = '0';
        this.temp.gwServiceQtsf = '0';
        this.temp.gwServiceFjhsc = '0';
        this.temp.gwServiceLnrzytz = '0';
        this.temp.gwServiceEtzyy = '0';
        this.temp.gwServiceDcasc = '0';
        this.temp.gwServiceFnlasc = '0';
        this.temp.gwServiceXnxg = '0';
        this.temp.gwServiceMzfsc = '0';
        this.temp.gwServiceQtsc = '0';
        this.temp.gwServiceEtjkgl = '0';
        this.temp.gwServiceJztx = '0';
        this.temp.gwServiceYcfgl = '0';
        this.temp.gwServiceChfsyy = '0';
        this.temp.gwServiceQt1 = '0';
        this.temp.gwServiceQt1Str = '';
        this.temp.gwServiceQt2 = '0';
        this.temp.gwServiceQt2Str = '';
        this.temp.ylServiceZlyy = '0';
        this.temp.ylServiceZzhsf = '0';
        this.temp.ylServiceYlzx = '0';
        this.temp.ylServiceYszx = '0';
        this.temp.ylServiceWjtz = '0';
        this.temp.ylServiceZyxc = '0';
        this.temp.ylServiceZyykfzd = '0';
        this.temp.ylServiceXlaw = '0';
        this.temp.ylServiceQt1 = '0';
        this.temp.ylServiceQt1Str = '';
        this.temp.ylServiceQt2 = '0';
        this.temp.ylServiceQt2Str = '';
        this.temp.gxhServiceTxsm = '0';
        this.temp.gxhServiceJtbc = '0';
        this.temp.gxhServiceJkgl = '0';
        this.temp.gxhServiceZyzwb = '0';
        this.temp.gxhServiceXxhyl = '0';
        this.temp.gxhServiceQt1 = '0';
        this.temp.gxhServiceQt1Str = '';
        this.temp.gxhServiceQt2 = '0';
        this.temp.gxhServiceQt2Str = '';

        // this.temp.id = '';
        // this.temp.name = '';
        // this.temp.remark = '';
        //
        // this.$nextTick(() => {      //清空校验
        //   this.$refs['dataForm'].clearValidate()
        // })
      },
		}
	}
</script>

<style scope>
.my-custom-dialog .el-dialog__body {
  max-height: 100vh !important;
  overflow-y: auto !important;
}
.input-bg .el-input__inner {
    background-color: #fff8d1 !important;
}
.main-form  .el-form-item__label {
    font-weight: 700 !important;
}
.is-readonly {
  pointer-events: none;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/contact/contactEnter-add-or-edit.vue